import { useRolodexFileLS, useRolodexSignedURLs } from 'features/rolodex'
import { useEffect, useState } from 'react'

export const usePdfPreview = (
  entryId: string,
  fileType: string,
  setShowPdfPreviewer: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const [pdfURL, setPdfURL] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(false)

  const { fileRefs } = useRolodexFileLS({
    entry_id: entryId,
    path: '**',
  })

  const { url } = useRolodexSignedURLs(fileRefs)

  useEffect(() => {
    const fetchPdf = async () => {
      if (!url) {
        console.error('No URL available to preview')
        return
      }
      if (fileType !== 'pdf') {
        console.error('Can only preview PDFs')
      }

      setIsLoading(true)
      setShowPdfPreviewer(true)
      if (fileType.toLowerCase() === 'pdf') {
        try {
          const response = await fetch(url)
          if (!response.ok) {
            console.error('Failed to fetch PDF')
            return
          }
          const blob = await response.blob()
          const appBlob = new Blob([blob], { type: 'application/pdf' })
          const fetchedURL = URL.createObjectURL(appBlob)
          setPdfURL(fetchedURL)
        } catch (error) {
          console.error('Error fetching the PDF:', error)
        } finally {
          setIsLoading(false)
        }
      } else {
        setPdfURL(null)
        setIsLoading(false)
      }
    }

    fetchPdf()
  }, [url, fileType, setShowPdfPreviewer])

  return { pdfURL, isLoading }
}
